import Cookies from 'js-cookie'

const TokenKey = 'loginToken'
const authorizationKey = 'authorization'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}




export function getAuthorization() {
  return Cookies.get(authorizationKey)
}

export function setAuthorization(token) {
  return Cookies.set(authorizationKey, token)
}

export function removeAuthorization() {
  return Cookies.remove(authorizationKey)
}




// WEBPACK FOOTER //
// ./src/utils/auth.js